import { provideState } from '@ngrx/store';

import { userInstitutionLoginsFeature } from './user-institution-logins.reducer';

export const userInstitutionLoginsStore = [
  provideState(userInstitutionLoginsFeature),
];
